import React from 'react'
import { Consumer } from '../../context';
import ImageCardLight from '../Cards/ImageCardLight';
import {v4 as uuid} from 'uuid';

function PopCulture() {

    return (
        <Consumer>
            {(value) => {

                const {popCulture} = value;

                return (
                    <div>
                        <div className="font-monospace text-center">
                            <div className="container-fluid pageHeading py-5" >
                                <div className="fs-1">
                                    Pop Culture
                                </div>
                            </div>

                            <div
                                className="container-fluid align-items-center  pageBackground"
                            >
                                <div className="container">
                                    <div className="row pb-5 px-5 font-monospace">
                                        {popCulture.map((ill) => (
                                            <div key={uuid()} className="col-12 col-md-6 col-lg-4 py-lg-5 py-3">
                                                <ImageCardLight
                                                    //section={popCulture}
                                                    image={ill} />
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Consumer>
    )
}

export default PopCulture;
